import script from "./ManageStockForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManageStockForm.vue?vue&type=script&lang=ts&setup=true"

import "./ManageStockForm.vue?vue&type=style&index=0&id=a84a1806&lang=scss"

const __exports__ = script;

export default __exports__